import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    dashboardWrapper: {
        height: '100%',

        '& iframe': {
        boxShadow: 'none !important',
        border: 'none',
    },
    '& body': {
        backgroundColor: '#ffffff'
    }


    },
}));
